<template>
  <div>
    <rule-import-from-template
      v-if="ruleId == 0 || ruleId == -1"
      :name="name"
      :rule-config-id="configuration.id"
      :rule-group-id="ruleGroupId"
      class="mr-1 float-left"
    />

    <button
      v-if="(ruleId == 0 || ruleId == -1) && canUserEdit"
      v-b-modal="'editRule' + ruleId + (ruleGroup ? 'Grouped' : '')"
      v-b-tooltip.hover
      class="btn btn-success"
      placement="bottom"
      title="Regel hinzufügen"
      type="button"
      @click="
        ruleToEdit = ruleId;
        loadRule();
      "
    >
      <i class="fas fa-plus" />
    </button>
    <button
      v-else-if="canUserEdit"
      v-b-modal="'editRule' + ruleId + (ruleGroup ? 'Grouped' : '')"
      v-b-tooltip.hover
      class="btn btn-primary smallActionButton"
      placement="bottom"
      title="Regel bearbeiten"
      type="button"
      @click="
        ruleToEdit = ruleId;
        loadRule();
      "
    >
      <i class="fas fa-edit" />
    </button>

    <b-modal
      v-if="ruleToEdit || newRule"
      :id="'editRule' + ruleId + (ruleGroup ? 'Grouped' : '')"
      :ref="'editRule' + ruleId + (ruleGroup ? 'Grouped' : '')"
      :title="ruleId != 0 ? 'Regel bearbeiten' : 'Neue Regel'"
      hide-footer
      no-fade
      size="xl"
    >
      <u-error-handling
        v-if="errorObject"
        :error-object="errorObject"
      />
      <u-loader v-if="isLoading" />
      <div v-else>
        <div class="row">
          <div class="col-4 font-weight-bold">
            {{ "Sortierung" }}
          </div>
          <div class="col-8">
            <v-text-field
              v-model="ruleToEditObject.order"
              :label="'Sortierung'"
              type="number"
              :disabled="!canUserEdit"
            />
          </div>
        </div>
        <v-divider />
        <div
          v-for="(configEntry, index) in configuration.configEntries"
          :key="index"
          class="row mb-2"
        >
          <template
            v-if="
              (!ruleGroup && configEntry.criteriaStructure) ||
                (configEntry.criteriaStructure &&
                groupedRuleConfig &&
                groupedRuleConfig.groupEntries.filter((groupedConfigEntry) => {
                  return (
                    groupedConfigEntry.criteriaStructureId ==
                    configEntry.criteriaStructureId
                  );
                }).length == 0)
            "
          >
            <div class="col-4 font-weight-bold">
              {{ configEntry.criteriaStructure.name }}
            </div>
            <div class="col-8">
              <rule-criteria-autocomplete
                v-model="ruleToEditObject"
                :all-values="ruleToEditObject"
                :contract-id="contractId"
                :edition-id="editionId"
                :structure-item="configEntry"
                :version-number="versionId"
                collection-name="entries"
              />
            </div>
          </template>
          <template
            v-if="
              (!ruleGroup && configEntry.criteriaGroup) ||
                (configEntry.criteriaGroup &&
                groupedRuleConfig &&
                groupedRuleConfig.groupEntries.filter((groupedConfigEntry) => {
                  return (
                    groupedConfigEntry.criteriaGroupId ==
                    configEntry.criteriaGroupId
                  );
                }).length == 0)
            "
          >
            <div class="col-4 font-weight-bold">
              {{ configEntry.criteriaGroup.name }}
            </div>
            <div class="col-8">
              <v-select
                v-if="
                  ruleToEditObject.entries.filter((entry) => {
                    return entry.criteriaGroupId == configEntry.criteriaGroupId;
                  })[0]
                "
                v-model="
                  ruleToEditObject.entries.filter((entry) => {
                    return entry.criteriaGroupId == configEntry.criteriaGroupId;
                  })[0].value
                "
                :items="
                  GetValuesForGroupings(groupings, configEntry.criteriaGroupId)
                "
                item-text="value"
                item-value="value"
              />
            </div>
          </template>
          <template
            v-if="
              (!ruleGroup && configEntry.variable) ||
                (configEntry.variable &&
                groupedRuleConfig &&
                groupedRuleConfig.groupEntries.filter((groupedConfigEntry) => {
                  return groupedConfigEntry.variable == configEntry.variable;
                }).length == 0)
            "
          >
            <div class="col-4 font-weight-bold">
              {{ configEntry.variable.name }}
            </div>
            <div
              v-if="configEntry.variable.type == 4"
              class="col-8"
            >
              <v-select
                v-model="
                  ruleToEditObject.entries.filter((entry) => {
                    return entry.variableId == configEntry.variableId;
                  })[0].value
                "
                :items="flagOptions"
                item-text="label"
                item-value="value"
              />
            </div>
            <div
              v-else
              class="col-8"
            >
              <v-text-field
                v-if="
                  ruleToEditObject.entries.filter((entry) => {
                    return entry.variableId == configEntry.variableId;
                  })[0]
                "
                v-model="
                  ruleToEditObject.entries.filter((entry) => {
                    return entry.variableId == configEntry.variableId;
                  })[0].value
                "
                :label="configEntry.variable.name"
              />
            </div>
          </template>
        </div>
      </div>
      <br>
      <b-button
        v-if="ruleToEdit && ruleToEdit.id != 0"
        variant="success"
        @click="saveRule(ruleToEdit)"
      >
        Speichern
      </b-button>
      <b-button
        v-else
        variant="success"
        @click="saveRule(ruleToEdit)"
      >
        Hinzufügen
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="
          hideModal('editRule' + ruleId + (ruleGroup ? 'Grouped' : ''));
          ruleToEdit = null;
        "
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import {
  GetSingleRule,
  AddRule,
  SaveRule,
  GetGroupedRuleConfiguration,
} from "@/services/minimum.wage.services/rules.minimum.wages.js";
import { GetValuesForGroupings } from "@/helpers/MinimumWageRulesHelper.js";
import RuleCriteriaAutocomplete from "@/components/minimum.wage/pages/Rules/RuleCriteriaAutocomplete.vue";
import RuleImportFromTemplate from "@/components/minimum.wage/pages/Rules/RuleImportFromTemplate.vue";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  components: {
    RuleCriteriaAutocomplete,
    RuleImportFromTemplate,
  },
  mixins: [MinimumWageMixin],
  props: {
    name: {
      type: String,
      default: "ValueSetting",
    },
    ruleId: {
      type: Number,
      required: true,
    },
    ruleGroup: {
      type: Object,
      default: () => null,
    },
    editMode: {
      type: Boolean,
      default: () => true,
    },
    configuration: {
      type: Object,
      required: true,
    },
    previousStructureProperties: {
      type: Array,
      default: () => [],
    },
    highestOrder: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      selected: [],
      isLoading: false,
      errorObject: null,
      groupConfiguration: null,
      groupProperties: [],
      hideSelection: true,
      ruleToEdit: null,
      ruleToEditObject: null,
      GetValuesForGroupings: GetValuesForGroupings,
      groupings: this.$store.state.mindestLohnKonfiguration.Groupings,
      selectedValues: [],
      objectToSave: {},
      newRule: false,
      groupedRuleConfig: null,
      flagOptions: [
        { label: "", value: "" },
        { label: "Ja", value: "Y" },
        { label: "Nein", value: "N" },
      ],
    };
  },
  computed: {
    ruleGroupId() {
      if (this.ruleGroup != null) return this.ruleGroup.id;

      return null;
    },
  },
  created() {
    // this.loadRule()
  },
  methods: {
    loadRule() {
      this.isLoading = true;

      if (this.ruleId == 0 || this.ruleId == -1) {
        this.ruleToEditObject = {
          id: 0,
          ruleConfigurationId: this.configuration.id,
          ruleGroupId: this.ruleGroup ? this.ruleGroup.id : null,
          order: this.highestOrder == null ? 0 : this.highestOrder + 10,
          entries: [],
        };

        this.configuration.configEntries.map((configEntry) => {
          var ruleValueEntry = this.ruleToEditObject.entries.filter((entry) => {
            return (
              (entry.criteriaGroupId &&
                entry.criteriaGroupId == configEntry.criteriaGroupId) ||
              (entry.criteriaStructureId &&
                entry.criteriaStructureId == configEntry.criteriaStructureId) ||
              (entry.variableId && entry.variableId == configEntry.variableId)
            );
          });

          if (ruleValueEntry.length == 0) {
            this.ruleToEditObject.entries.push({
              id: 0,
              ruleId: this.ruleToEditObject.id,
              criteriaStructureId:
                configEntry.criteriaStructureId != 0
                  ? configEntry.criteriaStructureId
                  : null,
              criteriaGroupId:
                configEntry.criteriaGroupId != 0
                  ? configEntry.criteriaGroupId
                  : null,
              criteriaPlzId:
                configEntry.criteriaPlzId != 0
                  ? configEntry.criteriaPlzId
                  : null,
              variableId:
                configEntry.variableId != 0 ? configEntry.variableId : null,
              value: "",
              criteriaListEntryId: null,
            });
          }
        });

        // if there is a ruleGroupId, the rule is grouped
        // this means we need to remove the grouped properties
        if (this.ruleGroup) {
          this.loadGroupedConfiguration();
        } else {
          this.isLoading = false;
        }

        this.newRule = true;
        this.isLoading = false;

        return;
      }

      GetSingleRule(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        this.ruleId,
        (response) => {
          this.isLoading = false;
          this.ruleToEditObject = response;
          this.configuration.configEntries.map((configEntry) => {
            var ruleValueEntry = this.ruleToEditObject.entries.filter(
              (entry) => {
                return (
                  (entry.criteriaGroupId &&
                    entry.criteriaGroupId == configEntry.criteriaGroupId) ||
                  (entry.criteriaStructureId &&
                    entry.criteriaStructureId ==
                      configEntry.criteriaStructureId) ||
                  (entry.variableId &&
                    entry.variableId == configEntry.variableId)
                );
              },
            );

            if (ruleValueEntry.length == 0) {
              this.ruleToEditObject.entries.push({
                id: 0,
                ruleId: this.ruleToEditObject.id,
                criteriaStructureId:
                  configEntry.criteriaStructureId != 0
                    ? configEntry.criteriaStructureId
                    : null,
                criteriaGroupId:
                  configEntry.criteriaGroupId != 0
                    ? configEntry.criteriaGroupId
                    : null,
                variableId:
                  configEntry.variableId != 0 ? configEntry.variableId : null,
                value: "",
                criteriaListEntryId: null,
              });
            }
          });

          // if there is a ruleGroupId, the rule is grouped
          // this means we need to remove the grouped properties
          if (response.ruleGroupId) {
            this.loadGroupedConfiguration();
          }
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
    saveRule() {
      this.isLoading = true;

      if (this.ruleId == 0 || this.ruleId == -1) {
        AddRule(
          this.contractId,
          this.versionId,
          this.editionId,
          this.configuration.id,
          this.ruleToEditObject,
          () => {
            this.isLoading = false;
            this.hideModal(
              "editRule" + this.ruleId + (this.ruleGroup ? "Grouped" : ""),
            );
            this.$emit("ruleSaved");
          },
          (error) => {
            this.isLoading = false;
            this.errorObject = error;
          },
        );
      } else {
        SaveRule(
          this.contractId,
          this.versionId,
          this.editionId,
          this.configuration.id,
          this.ruleToEditObject,
          () => {
            this.isLoading = false;
            this.hideModal(
              "editRule" + this.ruleId + (this.ruleGroup ? "Grouped" : ""),
            );
            this.$emit("ruleSaved");
          },
          (error) => {
            this.isLoading = false;
            this.errorObject = error;
          },
        );
      }
    },
    loadGroupedConfiguration() {
      this.errorObject = null;

      GetGroupedRuleConfiguration(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        this.ruleGroup.id,
        (response) => {
          this.groupedRuleConfig = response;

          response.groupEntries.map((groupEntry) => {
            var propertyToSetFromConfig = this.ruleToEditObject.entries.filter(
              (property) => {
                return groupEntry.criteriaStructureId
                  ? groupEntry.criteriaStructureId ==
                      property.criteriaStructureId
                  : false || groupEntry.criteriaGroupId
                    ? groupEntry.criteriaGroupId == property.criteriaGroupId
                    : false;
              },
            );

            if (propertyToSetFromConfig[0]) {
              propertyToSetFromConfig[0].value = groupEntry.value;
              propertyToSetFromConfig[0].criteriaListEntryId =
                groupEntry.criteriaListEntryId;
            }
          });

          this.isLoading = false;
        },

        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style>
.menuable__content__active {
  z-index: 6000 !important;
}
</style>

<style scoped>
.smallActionButton {
  max-width: 25px;
  min-width: 25px;
  height: 25px;
  font-size: 17px;
  padding: 0px;
}
</style>
